import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/downloads/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

export const hasSourceDownloads = (textValue: string, state: State) =>
  fetchWithParamValidation(
    ({ value }) => getFromHamsClient(`/product/${value}/hasSourceDownloads`, state),
    {
      value: textValue,
    },
  );

export const getProductSourceDownload = (key: boolean, state: State) =>
  fetchWithParamValidation(
    ({ productKey }) => getFromHamsClient(`/source/product/${productKey}`, state),
    {
      productKey: key,
    },
  );

export const getSourceDownloadURL = (sourceId: string, downloadType: boolean, state: State) =>
  fetchWithParamValidation(
    ({ id, type }) => getFromHamsClient(`/source/${id}/sourceUrl/${type}`, state),
    {
      id: sourceId,
      type: downloadType,
    },
  );
